import React, { useState, useEffect } from 'react';
import '../styles/ModalTarefas.css';

const ModalTarefas = ({ isOpen, onClose, tarefa, onSave }) => {
  const [formData, setFormData] = useState({
    titulo: '',
    prazo: '',
    status: 'Pendente'
  });

  useEffect(() => {
    if (tarefa) {
      // Modo edição - preencher com dados da tarefa
      setFormData({
        titulo: tarefa.titulo || '',
        prazo: tarefa.prazo ? tarefa.prazo.split('T')[0] : '', // Formatar data
        status: tarefa.status || 'Pendente'
      });
    } else {
      // Modo criação - limpar formulário
      setFormData({
        titulo: '',
        prazo: '',
        status: 'Pendente'
      });
    }
  }, [tarefa, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.titulo.trim()) {
      alert('⚠️ O título da tarefa é obrigatório!');
      return;
    }

    onSave(formData);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content modal-tarefas">
        <div className="modal-header">
          <h2>{tarefa ? '✏️ Editar Tarefa' : '➕ Nova Tarefa'}</h2>
          <button className="close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-body">
          <div className="form-group">
            <label htmlFor="titulo">
              Título da Tarefa <span className="required">*</span>
            </label>
            <input
              type="text"
              id="titulo"
              name="titulo"
              value={formData.titulo}
              onChange={handleChange}
              placeholder="Digite o título da tarefa..."
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="prazo">Prazo</label>
            <input
              type="date"
              id="prazo"
              name="prazo"
              value={formData.prazo}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="status">Status</label>
            <select
              id="status"
              name="status"
              value={formData.status}
              onChange={handleChange}
            >
              <option value="Pendente">⏳ Pendente</option>
              <option value="Em Progresso">🔄 Em Progresso</option>
              <option value="Finalizado">✅ Finalizado</option>
            </select>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-cancel" onClick={onClose}>
              Cancelar
            </button>
            <button type="submit" className="btn-save">
              <i className="fas fa-check"></i>
              {tarefa ? 'Salvar Alterações' : 'Criar Tarefa'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalTarefas;
